import { render, staticRenderFns } from "./bank-document-upload.vue?vue&type=template&id=005fb251&lang=pug"
import script from "./bank-document-upload.vue?vue&type=script&lang=ts"
export * from "./bank-document-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports